
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.936 6.884a1.46 1.46 0 110-2.918 1.46 1.46 0 010 2.918z","fill":"#7B01B5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.453.02h.078l5.838.418a2.82 2.82 0 012.559 2.557l.428 5.834a1.837 1.837 0 01-.506 1.458l-8.212 8.207A1.81 1.81 0 019.344 19a2.716 2.716 0 01-1.946-.846L1.2 11.97a2.303 2.303 0 01-.341-3.2L9.119.507A1.84 1.84 0 0110.415 0l.039.02zm-.039 1.565a.292.292 0 00-.175 0L2.017 9.801a.972.972 0 00.35.973l6.218 6.213c.205.222.486.358.788.38h.165l8.193-8.256a.3.3 0 000-.214l-.428-5.834a1.235 1.235 0 00-1.012-1.04l-5.838-.418-.039-.02z","fill":"#7B01B5"}})])
          )
        }
      }
    